function initializeTimestampFields(context = document) {
  const timestampFields = context.querySelectorAll('input[name*="form_timestamp"]');
  if (timestampFields.length > 0) {
    timestampFields.forEach(timestampField => {
      timestampField.value = Math.floor(Date.now() / 1000).toString();
    });
  }
}

document.addEventListener('DOMContentLoaded', function() {
  initializeTimestampFields();

  // Use MutationObserver to detect DOM changes (including AJAX-injected forms)
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      // Check if new nodes were added
      if (mutation.addedNodes.length > 0) {
        mutation.addedNodes.forEach(function(node) {
          // Only process element nodes (not text nodes, etc.)
          if (node.nodeType === 1) {
            // Check if the added node is a form or contains a form
            if (node.matches && (node.matches('form') || node.querySelector('form'))) {
              initializeTimestampFields(node);
            }

            // Also check if timestamp fields were added directly
            if (node.matches && node.matches('input[name*="form_timestamp"]')) {
              node.value = Math.floor(Date.now() / 1000).toString();
            }
          }
        });
      }
    });
  });

  // Start observing the document body for DOM changes
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});